import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { useState, useEffect } from 'react'
import AutoArchiveAfterImportAddEditDialog from './AutoArchiveAfterImportAddEditDialog'
import { ExplanationAccordion, LabelField } from 'components'
import { SettingsAutoArchiveAfterImportCancellationDateDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import * as controllers from 'controllers'

export default function AutoArchiveAfterImportListCard() {
  const [autoArchiveAfterImportCancellationDate, setAutoArchiveAfterImportCancellationDate] =
    useState<SettingsAutoArchiveAfterImportCancellationDateDto>(new SettingsAutoArchiveAfterImportCancellationDateDto())
  const [AutoArchiveAfterImportAddEditDialogOpen, setAutoArchiveAfterImportAddEditDialogOpen] = useState<boolean>(false)
  const [isSavingAutoArchiveAfterImportCancellationDate, setIsSavingAutoArchiveAfterImportCancellationDate] =
    useState<boolean>(false)
  const [isGettingAutoArchiveAfterImportCancellationDate, setIsGettingAutoArchiveAfterImportCancellationDate] =
    useState<boolean>(false)

  useEffect(() => {
    setIsGettingAutoArchiveAfterImportCancellationDate(true)
    controllers
      .getAutoArchiveAfterImportCancellationDateInformation()
      .then(response => {
        setAutoArchiveAfterImportCancellationDate(response.value)
      })
      .finally(() => {
        setIsGettingAutoArchiveAfterImportCancellationDate(false)
      })
  }, [])

  return (
    <>
      <AutoArchiveAfterImportAddEditDialog
        initialValues={autoArchiveAfterImportCancellationDate}
        isLoading={isSavingAutoArchiveAfterImportCancellationDate}
        onClose={() => {
          setAutoArchiveAfterImportAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsSavingAutoArchiveAfterImportCancellationDate(true)
          controllers
            .updateAutoArchiveAfterImportCancellationDateInformation(values)
            .then(response => {
              enqueueSnackbar('Auto Archive After Import Cancellation Date Saved Successfully!', { variant: 'success' })
              setAutoArchiveAfterImportCancellationDate(response.value)
              setAutoArchiveAfterImportAddEditDialogOpen(false)
            })
            .finally(() => {
              setIsSavingAutoArchiveAfterImportCancellationDate(false)
            })
        }}
        open={AutoArchiveAfterImportAddEditDialogOpen}
      />
      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm={9}>
                <Typography fontWeight='bold' variant='h5'>
                  Auto Archive After Import Cancellation Date
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button
                  onClick={() => {
                    setAutoArchiveAfterImportAddEditDialogOpen(true)
                  }}
                  variant='text'
                  endIcon={<Edit />}
                >
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingAutoArchiveAfterImportCancellationDate && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingAutoArchiveAfterImportCancellationDate && (
              <Grid item xs={12}>
                <LabelField
                  label='Number of Days After Cancel Import'
                  value={autoArchiveAfterImportCancellationDate.autoArchiveNumberOfDaysAfterCancelImport}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||Vehicle imports that were cancelled because they were never brought across the border get auto archived after
                the entered number of days. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
